'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserSettingsForm(defaultPharmacyRange, maximumPharmacyRange) {
  this.Lapp_data_GeneralPracticeUserSettingsForm__f_defaultPharmacyRange = 0;
  this.Lapp_data_GeneralPracticeUserSettingsForm__f_maximumPharmacyRange = 0;
  this.Lapp_data_GeneralPracticeUserSettingsForm__f_defaultPharmacyRange = defaultPharmacyRange;
  this.Lapp_data_GeneralPracticeUserSettingsForm__f_maximumPharmacyRange = maximumPharmacyRange;
}
export { $c_Lapp_data_GeneralPracticeUserSettingsForm as $c_Lapp_data_GeneralPracticeUserSettingsForm };
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.constructor = $c_Lapp_data_GeneralPracticeUserSettingsForm;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserSettingsForm() {
}
export { $h_Lapp_data_GeneralPracticeUserSettingsForm as $h_Lapp_data_GeneralPracticeUserSettingsForm };
$h_Lapp_data_GeneralPracticeUserSettingsForm.prototype = $c_Lapp_data_GeneralPracticeUserSettingsForm.prototype;
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1001202171, true);
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_GeneralPracticeUserSettingsForm) && ((this.Lapp_data_GeneralPracticeUserSettingsForm__f_defaultPharmacyRange === x$0.Lapp_data_GeneralPracticeUserSettingsForm__f_defaultPharmacyRange) && (this.Lapp_data_GeneralPracticeUserSettingsForm__f_maximumPharmacyRange === x$0.Lapp_data_GeneralPracticeUserSettingsForm__f_maximumPharmacyRange))));
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.productPrefix__T = (function() {
  return "GeneralPracticeUserSettingsForm";
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_GeneralPracticeUserSettingsForm__f_defaultPharmacyRange;
  }
  if ((n === 1)) {
    return this.Lapp_data_GeneralPracticeUserSettingsForm__f_maximumPharmacyRange;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_GeneralPracticeUserSettingsForm.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "defaultPharmacyRange";
  }
  if ((n === 1)) {
    return "maximumPharmacyRange";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_GeneralPracticeUserSettingsForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeUserSettingsForm)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeUserSettingsForm as $isArrayOf_Lapp_data_GeneralPracticeUserSettingsForm };
var $d_Lapp_data_GeneralPracticeUserSettingsForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserSettingsForm, "app.data.GeneralPracticeUserSettingsForm", ({
  Lapp_data_GeneralPracticeUserSettingsForm: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_GeneralPracticeUserSettingsForm as $d_Lapp_data_GeneralPracticeUserSettingsForm };
//# sourceMappingURL=app.data.-General-Practice-User-Settings-Form.js.map
